import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";
import { QueryOption } from "libs/react-query";
import * as KeyFactory from "./node-query-key-factory";
/**
 * Returns the children for a node
 * @param {string} nodeId - uuid of the node
 * @returns parent of the given node
 */
export const getNodeChildren = ({ nodeId }: { nodeId: string | null }) => {
  return nodeId === null ? Promise.reject(new Error("Invalid nodeId")) : Brm.nodeApi.getNodeChildren(nodeId);
};

interface INodeChildrenProps {
  nodeId: string | null;
  options?: QueryOption<typeof getNodeChildren>;
}

/**
 * Custom hook to retreive a children for a node
 *
 * @param {string} nodeId - uuid of a parent node
 * @param {object} options - react-query configuration object
 * @returns react-query for getNodeParent
 */
export const useNodeChildren = ({ nodeId, options = {} }: INodeChildrenProps) => {
  return ReactQuery.useQuery({
    ...options,
    queryKey: KeyFactory.nodeKeys.children(nodeId),
    queryFn: () => getNodeChildren({ nodeId }),
  });
};
